import { Invoice } from '../types/invoice';

export const checkOverdueInvoices = (invoices: Invoice[]): Invoice[] => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  return invoices.map(invoice => {
    if (invoice.status === 'sent' || invoice.status === 'viewed') {
      const dueDate = new Date(invoice.dueDate);
      dueDate.setHours(0, 0, 0, 0);
      
      if (dueDate < today) {
        return { ...invoice, status: 'overdue' as const };
      }
    }
    return invoice;
  });
};

export const generateRecurringInvoices = (invoices: Invoice[]): Invoice[] => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const newInvoices: Invoice[] = [];
  
  invoices.forEach(invoice => {
    if (invoice.isRecurring && invoice.nextRecurringDate) {
      const nextDate = new Date(invoice.nextRecurringDate);
      nextDate.setHours(0, 0, 0, 0);
      
      // Check if it's time to generate the next invoice
      if (nextDate <= today) {
        // Check if we've passed the end date
        if (invoice.recurringEndDate) {
          const endDate = new Date(invoice.recurringEndDate);
          endDate.setHours(0, 0, 0, 0);
          if (today > endDate) {
            return; // Don't generate if past end date
          }
        }
        
        // Calculate next recurring date
        const daysToAdd = invoice.recurringFrequency === 'monthly' ? 30 : 
                         invoice.recurringFrequency === 'quarterly' ? 90 : 365;
        const newNextDate = new Date(nextDate.getTime() + daysToAdd * 24 * 60 * 60 * 1000);
        const newDueDate = new Date(today.getTime() + 30 * 24 * 60 * 60 * 1000);
        
        // Generate new invoice
        const newInvoice: Invoice = {
          ...invoice,
          id: Date.now().toString() + Math.random(),
          invoiceNumber: `INV-${Date.now()}`,
          status: 'draft',
          issueDate: today.toISOString().split('T')[0],
          dueDate: newDueDate.toISOString().split('T')[0],
          nextRecurringDate: newNextDate.toISOString().split('T')[0],
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          stripePaymentIntentId: undefined,
          stripeInvoiceId: undefined,
          stripePaymentLinkId: undefined,
          paidDate: undefined,
        };
        
        newInvoices.push(newInvoice);
      }
    }
  });
  
  return newInvoices;
};

export const updateInvoiceNextRecurringDate = (invoice: Invoice): Invoice => {
  if (invoice.isRecurring && invoice.nextRecurringDate) {
    const daysToAdd = invoice.recurringFrequency === 'monthly' ? 30 : 
                     invoice.recurringFrequency === 'quarterly' ? 90 : 365;
    const nextDate = new Date(invoice.nextRecurringDate);
    const newNextDate = new Date(nextDate.getTime() + daysToAdd * 24 * 60 * 60 * 1000);
    
    return {
      ...invoice,
      nextRecurringDate: newNextDate.toISOString().split('T')[0],
    };
  }
  return invoice;
};
